var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0734 9.71387L8.50195 12.2853L11.0734 14.8567",
    stroke: "#1377D4",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93164 6.28543L8.50307 3.71401L5.93164 1.14258",
    stroke: "#1377D4",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50195 12.2853H13.6448C14.251 12.2853 14.8324 12.0445 15.2611 11.6158C15.6897 11.1872 15.9305 10.6058 15.9305 9.99958V5.99958C15.9305 5.39337 15.6897 4.81199 15.2611 4.38334C14.8324 3.95468 14.251 3.71387 13.6448 3.71387H11.9305",
    stroke: "#1377D4",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50279 3.71387H3.35993C2.75372 3.71387 2.17234 3.95468 1.74369 4.38334C1.31503 4.81199 1.07422 5.39337 1.07422 5.99958V9.99958C1.07422 10.6058 1.31503 11.1872 1.74369 11.6158C2.17234 12.0445 2.75372 12.2853 3.35993 12.2853H5.07422",
    stroke: "#1377D4",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.410a1fbaace85c6e0953fff2164d59d6.svg";
export { ForwardRef as ReactComponent };